module.exports = {
  'en': {
    'HRES31X27C': {
      '10': 'Seq No.',
      '20': 'Name',
      '30': 'Address',
      '40': 'Relation',
      '50': 'Inherit rate (%)'
    },
    'HRES31X27P': {
      '10': 'Details of Insured',
      '20': 'Employee ID',
      '30': 'Insurce Policy No.',
      '40': 'Insure Status',
      '50': 'List of Beneficiary',
      '60': 'Insurance Plan',
      '70': 'Status',
      '80': 'Covered Period',
      '90': 'To',
      '100': 'Insured Amount',
      '110': 'Covered For',
      '120': 'Change Date',
      '130': 'Insurance Premiun',
      '140': 'Amount',
      '150': 'Contributed By Company',
      '160': 'By Employee',
      '170': 'Remark'
    },
    'HRES31XC1': {
      '10': 'Title',
      '20': 'First Name',
      '30': 'Last Name',
      '40': 'Age',
      '50': 'Year',
      '60': 'Month',
      '70': 'No. Of Children',
      '80': 'Pers.',
      '90': 'Marital Status',
      '100': 'Gender',
      '110': 'Highest Education',
      '120': 'Institue',
      '130': 'Last Work Place',
      '140': 'Inhouse Phone',
      '150': 'Service Year',
      '160': 'Year',
      '170': 'Month',
      '180': 'Department',
      '190': 'Position',
      '200': 'Hired Date',
      '210': 'Employment Status',
      '220': 'Start Service Date',
      '230': 'Type of Employment',
      '240': 'Start Pos. Date',
      '250': 'Type Of Payroll',
      '260': 'Monthly Income',
      '270': 'Baht',
      '280': 'Function',
      '290': 'Personal Data',
      '300': 'Employment Data',
      '310': 'Income Data',
      '320': 'Tax Detail',
      '330': 'Education Data',
      '340': 'Work Experiences',
      '350': 'Parent"s Information',
      '360': 'Spouse Data',
      '370': 'Children Data',
      '380': 'Guarantor Information',
      '390': 'Collateral Inform.',
      '400': 'Competency Profile',
      '410': 'Training Record',
      '420': 'Honors',
      '430': 'Name Change',
      '440': 'Document',
      '450': 'Reference',
      '460': 'Other Data',
      '470': 'Other History'
    },
    'HRES31XC10': {
      '10': 'Children Data',
      '20': 'Seq. No',
      '30': 'Children"s Name',
      '40': 'Brith Date',
      '50': 'Gender',
      '60': 'Education Level',
      '70': 'Edu. Status',
      '80': 'Lower right'
    },
    'HRES31XC11': {
      '10': 'Guarantor',
      '20': 'Seq.No',
      '30': 'Guarantor name',
      '40': 'Guar. Date',
      '50': 'Exp. Date',
      '60': 'Relation',
      '70': 'Occupation'
    },
    'HRES31XC12': {
      '10': 'Collateral',
      '20': 'Collateral No.',
      '30': 'Type of collateral',
      '40': 'Value',
      '50': 'Document No.'
    },
    'HRES31XC13': {
      '10': 'Honors',
      '20': 'Receive date',
      '30': 'Type of Award',
      '40': 'Details',
      '50': 'Refer Doc. No.'
    },
    'HRES31XC14': {
      '10': 'Name Change',
      '20': 'Date',
      '30': 'Title',
      '40': 'Name',
      '50': 'Last Name',
      '60': 'Reason of change'
    },
    'HRES31XC15': {
      '10': 'Competency',
      '20': 'Type of Competency',
      '30': 'Code',
      '40': 'Description',
      '50': 'Full Score',
      '60': 'Score',
      '70': 'Remark :',
      '80': 'Black text is JD skills of employee.',
      '90': 'Gray text is other skills of employee.',
      '300': 'level'
    },
    'HRES31XC16': {
      '10': 'Document',
      '20': 'Seq.',
      '30': 'Document Name',
      '40': 'Document File',
      '50': 'Received Date',
      '60': 'Document Type',
      '70': 'Document Date End',
      '80': 'Document File',
      '90': 'Destcription'
    },
    'HRES31XC17': {
      '10': 'Reference',
      '20': 'Seq.No.',
      '30': 'Name',
      '40': 'Ref.Type',
      '50': 'Company',
      '60': 'Position',
      '70': 'Telephone',
      '80': 'Contact Address',
      '90': 'E-mail',
      '100': 'Occupation',
      '110': 'Comments'
    },
    'HRES31XC18': {
      '10': 'Other Data',
      '20': 'No.',
      '30': 'Description',
      '40': 'Value'
    },
    'HRES31XC19': {
      '10': 'Training Record',
      '20': 'Seq.',
      '30': 'Training Course',
      '40': 'Train Date',
      '50': 'Venue',
      '60': 'Organized By'
    },
    'HRES31XC2': {
      '10': 'Personal Data',
      '20': 'Other Data',
      '30': 'Blood Gr.',
      '40': 'Weight',
      '50': 'Hight',
      '60': 'Relegion',
      '70': 'Birth Place',
      '80': 'Race',
      '90': 'Nationality',
      '100': 'Ref. App. No.',
      '110': 'Driving Lic.no',
      '120': 'Expire Date',
      '130': 'Passport No.',
      '140': 'Expire Date',
      '150': 'Work Permit No.',
      '160': 'Work Per. Issue Date',
      '170': 'Work Per. Expire  Date',
      '180': 'Other Information',
      '190': 'Date of Birth',
      '200': 'Marital Status',
      '210': 'Military Service',
      '220': 'ID Card',
      '230': 'ID. Card No.',
      '240': 'Place of Issue',
      '250': 'Province',
      '260': 'Expire Date',
      '270': 'Address',
      '280': 'Regis. Address',
      '290': 'District',
      '300': 'Amphur',
      '310': 'Province',
      '320': 'Country',
      '330': 'Post/Zip',
      '340': 'Contact Address',
      '350': 'District',
      '360': 'Amphur',
      '370': 'Province',
      '380': 'Country',
      '390': 'Post/Zip',
      '400': 'Tel. No.'
    },
    'HRES31XC26': {
      '10': 'Social W/F / Entitleed Hospital',
      '20': 'Details',
      '30': 'For Employee',
      '40': 'SSF ID/ID Card',
      '50': 'วันที่จ่ายเงินสมทบครบ 90 วัน',
      '60': 'Entitled Hospital'
    },
    'HRES31XC27': {
      '10': 'Insured Information',
      '20': 'Emp. ID',
      '30': 'Insurce Policy No.',
      '40': 'Insurce Plan',
      '50': 'Covered Period',
      '60': 'From',
      '70': 'To',
      '80': 'Status'
    },
    'HRES31XC28': {
      '10': 'Benefits Entitlement',
      '20': 'Emp. Code',
      '30': 'As of date',
      '40': 'Benefits Limit : Per Year',
      '50': 'Benefits Limit : For Service Life',
      '60': 'BF Code',
      '70': 'Description',
      '80': 'Eff. Date',
      '90': 'From',
      '100': 'To',
      '110': 'Amount',
      '120': 'Max',
      '130': 'Amount',
      '140': 'Per Max',
      '150': 'Max',
      '160': 'Per Case',
      '170': 'Unit',
      '180': 'BF Code',
      '190': 'Description',
      '200': 'Eff. Date',
      '210': 'From',
      '220': 'To',
      '230': 'Amount',
      '240': 'Max',
      '250': 'Amount',
      '260': 'Per Max',
      '270': 'Max',
      '280': 'Per Case',
      '290': 'Unit',
      '300': 'Type of Benefits',
      '310': 'Cash',
      '320': 'Anything',
      '330': 'Total Benefits By Type'
    },
    'HRES31XC29': {
      '10': 'Employee Career Plan',
      '20': 'Emp. ID',
      '30': 'Reviewed Date',
      '40': 'Reviewed By',
      '50': 'Remarks',
      '60': 'Seq.',
      '70': 'Position',
      '80': 'Department',
      '90': 'Job Description',
      '100': 'Service Period in Pos.',
      '110': 'Start Working Date'
    },
    'HRES31XC3': {
      '10': 'Employment Data',
      '20': 'Hired Date',
      '30': 'Department',
      '40': 'Position',
      '50': 'Work Location',
      '60': 'Type of Employment',
      '70': 'Payroll Group',
      '80': 'Type of Employee',
      '90': 'Working Group',
      '100': 'Job Description',
      '110': 'Level',
      '120': 'Resign Date',
      '130': 'Appoint.date for level',
      '140': 'Probation Period(Day)',
      '150': 'Day',
      '160': 'Employment Period',
      '170': 'Yrs.',
      '180': 'Month',
      '190': 'Email-Address',
      '200': 'Last Update Date',
      '210': 'Confirmation Date',
      '220': 'Refered P.R. No.',
      '230': 'Employee Status',
      '240': 'Clock Time req.',
      '250': 'Appoint.date for Pos.',
      '260': 'Inhouse Phone No.',
      '270': 'By',
      '280': 'Job Grade',
      '290': 'Group GL',
      '300': 'Start Date in Job Grade'
    },
    'HRES31XC30': {
      '10': 'Competency Gap Analysis',
      '20': 'Competency Code',
      '30': 'Detail of Competency',
      '40': 'Score',
      '50': 'Average Score',
      '60': 'Show Graph'
    },
    'HRES31XC4': {
      '10': 'Income Data',
      '20': 'Currency',
      '30': 'Description',
      '40': 'Unit',
      '50': 'Amount',
      '60': 'Hourly Wage',
      '70': 'Daily Wage',
      '80': 'Monthly income'
    },
    'HRES31XC6': {
      '10': 'Education Data',
      '20': 'Seq.',
      '30': 'Education Level',
      '40': 'Field',
      '50': 'Major',
      '60': 'Institute',
      '70': 'Country',
      '80': 'Minor',
      '90': 'G.P.A',
      '100': 'Graduate in Year',
      '110': 'Type of Degree'
    },
    'HRES31XC7': {
      '10': 'Work Experiences',
      '20': 'Seq.',
      '30': 'Employer"s Name',
      '40': 'Type of business',
      '50': 'Position',
      '60': 'Start Date',
      '70': 'Resigned Date',
      '80': 'Reason of Leaving',
      '90': 'Location',
      '100': 'Telephone',
      '110': 'Supervisor Name',
      '120': 'Last Salary',
      '130': 'Remark'
    },
    'HRES31XC8': {
      '10': 'Parent"s Information',
      '20': 'Father"s Information',
      '30': 'Name',
      '40': 'Nationality',
      '50': 'Relegion',
      '60': 'Occupation',
      '70': 'Mother"s Information',
      '80': 'Name',
      '90': 'Nationality',
      '100': 'Relegion',
      '110': 'Occupation',
      '120': 'Emergency Contact Person',
      '130': 'Name',
      '140': 'Relationship',
      '150': 'Address',
      '160': 'Post/Zip',
      '170': 'Tel. No',
      '180': 'Fax.no',
      '190': 'Email-Address',
      '200': 'Last Update Date',
      '210': 'By',
      '220': 'Citizen I.d',
      '230': 'Citizen I.D'
    },
    'HRES31XC9': {
      '10': 'Spouse Data',
      '20': 'Spouse Information',
      '30': 'Name',
      '40': 'Citizen ID',
      '50': 'Occupation',
      '60': 'Birth Date',
      '70': 'Company',
      '80': 'Registration Information',
      '90': 'Registration date',
      '100': 'City',
      '110': 'Country',
      '120': 'Place',
      '130': 'Other Information',
      '140': 'Last Update Date',
      '150': 'By',
      '160': 'Spouse" Father ID',
      '170': 'Spouse" Mother ID'
    },
    'HRES31C5P1': {
      '10': 'Detail of Tax',
      '20': 'Detail of Tax',
      '30': 'Tax I.D',
      '40': 'Tax Deduction',
      '50': 'Type Of Tax Payment',
      '60': 'Social sec.no',
      '70': 'Date for 90 day contr.',
      '80': 'Entitled Hospital',
      '90': 'Bank Account info.',
      '100': 'Bank Code(1)',
      '110': 'Account No.',
      '120': '% Deposit',
      '130': 'Bank Code(2)',
      '140': '% Deposit'
    },
    'HRES31C5P2': {
      '10': 'Carried Over Income',
      '20': 'Carried Over For Emp.',
      '30': 'Bal. Forward Date',
      '40': 'Toptal Income',
      '50': 'P/F Contribution',
      '60': 'Tax Deduction',
      '70': 'Social W/F contr.',
      '80': 'Carried Over Income (Spouse)',
      '90': 'Bal. Forward Date',
      '100': 'Total Income',
      '110': 'P/F Contribution',
      '120': 'Tax Deduction',
      '130': 'Social W/F contr.',
      '140': 'Last update',
      '150': 'By'
    },
    'HRES31C5P3': {
      '10': 'Tax Exemption',
      '20': 'Code',
      '30': 'Description',
      '40': 'Amount.',
      '50': 'Amount.(Spouse)'
    },
    'HRES31C5P4': {
      '10': 'Tax Deduction',
      '20': 'Code',
      '30': 'Description',
      '40': 'Amount.',
      '50': 'Amount.(Spouse)',
      '60': 'Children who are studying',
      '70': 'People',
      '80': 'Children who do not study',
      '90': 'People'
    },
    'HRES31C5P5': {
      '10': 'Other Deduction',
      '20': 'Code',
      '30': 'Description',
      '40': 'Amount.',
      '50': 'Amount.(Spouse)'
    },
    'HRES31C5P6': {
      '500': 'Account No.'
    },
    'HRRC21P1': {
      '0': 'General Data',
      '10': 'Applicant No.',
      '20': 'Title',
      '30': 'Nickname',
      '40': 'Name',
      '50': 'LastName',
      '60': 'Applied Date',
      '70': 'Position applied',
      '80': 'Branch Applied',
      '90': 'Yes',
      '100': 'No',
      '110': 'Expected Income (P.M)',
      '120': 'Currency',
      '130': 'Source of Information',
      '140': 'File Image',
      '150': 'Own Car',
      '160': 'Yes',
      '170': 'No',
      '180': 'Ever Been Suspended ?',
      '190': 'Yes',
      '200': 'No',
      '1001': 'Applicant"s Information',
      '1080': 'Personal Data',
      '1085': 'Gender',
      '1090': 'Male',
      '1095': 'Female',
      '1100': 'Height',
      '1105': 'Weight',
      '1110': 'Birth Date',
      '1115': 'Place of Birth',
      '1120': 'Nationality',
      '1135': 'Marital Status',
      '1140': 'Military Service',
      '1145': 'I.D. Card No.',
      '1150': 'Place of Issue',
      '1165': 'English',
      '1170': 'Record Job Application Data',
      '1175': 'Language',
      '1180': 'Description',
      '1185': '2nd  Position Applied'
    },
    'STD_SKILSC': {
      '10': 'Competency Evaluation',
      '30': 'Level',
      '40': 'Index',
      '50': 'Score'
    }
  },
  'th': {
    'HRES31X27C': {
      '10': 'ลำดับที่',
      '20': 'ชื่อ',
      '30': 'ที่อยู่',
      '40': 'ความสัมพันธ์',
      '50': 'ผลประโยชน์ (%)'
    },
    'HRES31X27P': {
      '10': 'รายละเอียดผู้เอาประกัน',
      '20': 'พนักงาน',
      '30': 'เลขที่กรมธรรม์',
      '40': 'สถานภาพการประกัน',
      '50': 'ข้อมูลผู้รับผลประโยชน์',
      '60': 'แผนประกัน',
      '70': 'สถานะ',
      '80': 'ระยะเวลาเอาประกัน',
      '90': 'ถึง',
      '100': 'วงเงินประกัน',
      '110': 'สิทธิครอบคลุม',
      '120': 'วันที่ขอเปลี่ยน',
      '130': 'เบี้ยประกัน',
      '140': 'จำนวนเงิน',
      '150': 'บริษัทจ่าย',
      '160': 'พนักงานจ่าย',
      '170': 'หมายเหตุ'
    },
    'HRES31XC1': {
      '10': 'คำนำหน้า',
      '20': 'ชื่อพนักงาน',
      '30': 'นามสกุล',
      '40': 'อายุ',
      '50': 'ปี',
      '60': 'เดือน',
      '70': 'จำนวนบุตร',
      '80': 'คน',
      '90': 'สถานภาพการสมรส',
      '100': 'เพศ',
      '110': 'ระดับการศึกษาสูงสุด',
      '120': 'สถาบัน',
      '130': 'ที่ทำงานล่าสุด',
      '140': 'โทรศัพท์ติดต่อภายใน',
      '150': 'อายุงาน',
      '160': 'ปี',
      '170': 'เดือน',
      '180': 'หน่วยงาน',
      '190': 'ตำแหน่ง',
      '200': 'วันที่เข้างาน',
      '210': 'สถานภาพพนักงาน',
      '220': 'วันที่บรรจุ',
      '230': 'ประเภทการจ้างงาน',
      '240': 'วันที่เริ่มตำแหน่ง',
      '250': 'ประเภทการจ่ายเงินเดือน',
      '260': 'จำนวนเงินได้รวม',
      '270': 'บาท',
      '280': 'Function',
      '290': 'ข้อมูลส่วนตัว',
      '300': 'ข้อมูลจ้างงาน',
      '310': 'ข้อมูลรายได้',
      '320': 'รายละเอียดภาษี',
      '330': 'ข้อมูลการศึกษา',
      '340': 'ประสบการณ์การทำงาน',
      '350': 'ข้อมูลบิดา-มารดา ผู้ติดต่อได้',
      '360': 'ข้อมูลคู่สมรส',
      '370': 'ข้อมูลบุตร',
      '380': 'ข้อมูลผู้ค้ำประกัน',
      '390': 'ข้อมูลหลักทรัพย์ค้ำประกัน',
      '400': 'ความสามารถพิเศษ',
      '410': 'ข้อมูลการฝึกอบรม',
      '420': 'ข้อมูลคุณงามความดี',
      '430': 'การเปลี่ยนชื่อ-นามสกุล',
      '440': 'เอกสารส่วนตัว',
      '450': 'บุคคลอ้างอิง',
      '460': 'รายละเอียดอื่น ๆ',
      '470': 'ประวัติส่วนตัวอื่นๆ'
    },
    'HRES31XC10': {
      '10': 'ข้อมูลบุตร',
      '20': 'ลำดับที่',
      '30': 'ชื่อบุตร',
      '40': 'เลขที่บัตรประชาชน',
      '50': 'วันเกิด',
      '60': 'เพศ',
      '70': 'สถานะการศึกษา',
      '80': 'สิทธิ์ลดหย่อน'
    },
    'HRES31XC11': {
      '10': 'ข้อมูลผู้ค้ำประกัน',
      '20': 'ลำดับที่',
      '30': 'ชื่อผู้ค้ำประกัน',
      '40': 'วันค้ำประกัน',
      '50': 'วันที่สิ้นสุด',
      '60': 'ความสัมพันธ์',
      '70': 'อาชีพ'
    },
    'HRES31XC12': {
      '10': 'หลักทรัพย์',
      '20': 'รหัสหลักทรัพย์',
      '30': 'ประเภทหลักทรัพย์',
      '40': 'มูลค่า',
      '50': 'เลขที่เอกสาร'
    },
    'HRES31XC13': {
      '10': 'ข้อมูลคุณงามความดี',
      '20': 'วันที่บันทึก',
      '30': 'ประเภทรางวัล',
      '40': 'รายละเอียดคุณความดี',
      '50': 'เลขที่เอกสารอ้างอิง'
    },
    'HRES31XC14': {
      '10': 'ข้อมูลการเปลี่ยนชื่อ-นามสกุล',
      '20': 'วันที่',
      '30': 'คำนำหน้า',
      '40': 'ชื่อ',
      '50': 'นามสกุล',
      '60': 'เหตุผลที่เปลี่ยน'
    },
    'HRES31XC15': {
      '10': 'ความสามารถพิเศษ',
      '20': 'ประเภทความสามารถ',
      '30': 'รหัส',
      '40': 'รายละเอียด',
      '50': 'คะแนนเต็ม',
      '60': 'คะแนนที่ได้',
      '70': 'หมายเหตุ :',
      '80': 'ตัวอักษรสีดำ หมายถึง ประเภทความสามารถตาม JD ของพนักงาน',
      '90': 'ตัวอักษรสีเทา หมายถึง ประเภทความสามารถอื่นๆ ของพนักงาน',
      '300': 'ระดับความสามารถ'
    },
    'HRES31XC16': {
      '10': 'เอกสารส่วนตัว',
      '20': 'ลำดับที่',
      '30': 'ประเภทเอกสาร',
      '40': 'ชื่อเอกสาร',
      '50': 'วันที่รับเอกสาร',
      '60': 'วันที่หมดอายุ',
      '70': 'เลขที่เอกสาร',
      '80': 'ชื่อแฟ้มข้อมูล',
      '90': 'รายละเอียดอื่นๆ'
    },
    'HRES31XC17': {
      '10': 'บุคคลอ้างอิง',
      '20': 'ลำดับที่',
      '30': 'ชื่อ',
      '40': 'ความสัมพันธ์',
      '50': 'บริษัท',
      '60': 'ตำแหน่ง',
      '70': 'โทรศัพท์',
      '80': 'ที่อยู่',
      '90': 'อีเมล์',
      '100': 'อาชีพ',
      '110': 'หมายเหตุ'
    },
    'HRES31XC18': {
      '10': 'ข้อมูลอื่น ๆ',
      '20': 'ลำดับที่',
      '30': 'รายละเอียด',
      '40': 'ค่าข้อมูล'
    },
    'HRES31XC19': {
      '10': 'ข้อมูลการฝึกอบรม',
      '20': 'ลำดับ',
      '30': 'หลักสูตรอบรม',
      '40': 'วันที่อบรม',
      '50': 'สถานที่',
      '60': 'จัดโดย'
    },
    'HRES31XC2': {
      '10': 'ข้อมูลส่วนตัว',
      '20': 'รายละเอียดอื่น ๆ',
      '30': 'กรุ๊ปเลือด',
      '40': 'น้ำหนัก',
      '50': 'ส่วนสูง',
      '60': 'ศาสนา',
      '70': 'สถานที่เกิด',
      '80': 'เชื้อชาติ',
      '90': 'สัญชาติ',
      '100': 'อ้างถึงเลขที่ใบสมัคร',
      '110': 'เลขที่ใบขับขี่',
      '120': 'วันหมดอายุ',
      '130': 'เลขที่หนังสือเดินทาง',
      '140': 'วันหมดอายุ',
      '150': 'ใบอนุญาติทำงานเลขที่',
      '160': 'ออก ณ วันที่',
      '170': 'วันที่หมดอายุ',
      '180': 'ข้อมูลอื่นๆ',
      '190': 'วันเกิด',
      '200': 'สถานภาพสมรส',
      '210': 'สถานะทหาร',
      '220': 'บัตรประชาชน',
      '230': 'เลขที่บัตรประชาชน',
      '240': 'ออกบัตรที่',
      '250': 'จังหวัด',
      '260': 'วันสิ้นสุด',
      '270': 'ที่อยู่',
      '280': 'ตามทะเบียนบ้าน',
      '290': 'ตำบล',
      '300': 'อำเภอ',
      '310': 'จังหวัด',
      '320': 'ประเทศ',
      '330': 'รหัสไปรษณีย์',
      '340': 'ที่อยู่ที่ติดต่อได้',
      '350': 'ตำบล',
      '360': 'อำเภอ',
      '370': 'จังหวัด',
      '380': 'ประเทศ',
      '390': 'รหัสไปรษณีย์',
      '400': 'โทรศัพท์'
    },
    'HRES31XC26': {
      '10': 'ข้อมูลประกันสังคม/สถานพยาบาลที่มีสิทธิ',
      '20': 'รายละเอียด',
      '30': 'สำหรับพนักงาน',
      '40': 'เลขที่บัตรประกันสั้งคม/บัตรประชาชน',
      '50': 'วันที่จ่ายเงินสมทบครบ 90 วัน',
      '60': 'รหัสสถานพยาบาลที่มีสิทธิ'
    },
    'HRES31XC27': {
      '10': 'รายละเอียดการประกัน',
      '20': 'รหัสพนักงาน',
      '30': 'เลขที่กรมธรรม์',
      '40': 'แผนประกัน',
      '50': 'ระยะเวลาประกัน',
      '60': 'จาก',
      '70': 'ถึง',
      '80': 'สถานะ'
    },
    'HRES31XC28': {
      '10': 'สิทธิการเบิกสวัสดิการ',
      '20': 'รหัสพนักงาน',
      '30': 'ณ วันที่',
      '40': 'จำนวนที่มีสิทธิเบิก : ต่อปี',
      '50': 'จำนวนที่มีสิทธิเบิก : ตลอดอายุงาน',
      '60': 'รหัสสวัสดิการ',
      '70': 'รายละเอียด',
      '80': 'วันที่มีผล',
      '90': 'จาก',
      '100': 'ถึง',
      '110': 'จำนวน',
      '120': 'เบิกสูงสุด',
      '130': 'จำนวน',
      '140': 'ครั้งสูงสุด',
      '150': 'จำนวนเบิก',
      '160': 'ต่อครั้ง',
      '170': 'หน่วย',
      '180': 'รหัสสวัสดิการ',
      '190': 'รายละเอียด',
      '200': 'วันที่มีผล',
      '210': 'จาก',
      '220': 'ถึง',
      '230': 'จำนวน',
      '240': 'เบิกสูงสุด',
      '250': 'จำนวน',
      '260': 'ครั้งสูงสุด',
      '270': 'จำนวนเบิก',
      '280': 'ต่อครั้ง',
      '290': 'หน่วย',
      '300': 'ประเภทสวัสดิการ',
      '310': 'เงินสด',
      '320': 'สิ่งของ',
      '330': 'รวมสวัสดิการตามประเภทสวัสดิการ'
    },
    'HRES31XC29': {
      '10': 'Employee Career Plan',
      '20': 'รหัสพนักงาน',
      '30': 'วันที่พิจารณา',
      '40': 'พิจารณาโดย',
      '50': 'หมายเหตุ',
      '60': 'ลำดับ',
      '70': 'ตำแหน่ง',
      '80': 'หน่วยงาน',
      '90': 'ลักษณะงาน',
      '100': 'กำหนดอายุงาน',
      '110': 'วันที่เริ่มทำงาน'
    },
    'HRES31XC3': {
      '10': 'ข้อมูลจ้างงานปป',
      '20': 'วันที่เข้างาน',
      '30': 'หน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'สถานที่ทำงาน',
      '60': 'ประเภทการจ้างงาน',
      '70': 'กลุ่มการจ่ายเงินเดือน',
      '80': 'ประเภทพนักงาน',
      '90': 'กลุ่มพนักงาน',
      '100': 'ลักษณะงาน',
      '110': 'ระดับ',
      '120': 'วันที่พ้นสภาพ',
      '130': 'วันที่เริ่มระดับ',
      '140': 'กำหนดเวลาทดลองงาน',
      '150': 'วัน',
      '160': 'กำหนดระยะเวลาจ้างงาน',
      '170': 'ปี',
      '180': 'เดือน',
      '190': 'อีเมล์',
      '200': 'วันที่แก้ไขครั้งสุดท้าย',
      '210': 'วันที่บรรจุ',
      '220': 'เลขที่ใบขออนุมัติ',
      '230': 'สถานภาพพนง.',
      '240': 'บันทึกเวลา',
      '250': 'วันที่เริ่มตำแหน่ง',
      '260': 'เบอร์ติดต่อภายใน',
      '270': 'โดย',
      '280': 'Job Grade',
      '290': 'กลุ่ม GL',
      '300': 'วันที่เริ่ม Job Grade'
    },
    'HRES31XC30': {
      '10': 'เปรียบเทียบความสามารถ',
      '20': 'รหัสความสามารถ',
      '30': 'รายละเอียดความสามารถ',
      '40': 'คะแนนที่ได้',
      '50': 'คะแนนเฉลี่ย',
      '60': 'แสดงกราฟ'
    },
    'HRES31XC4': {
      '10': 'ข้อมูลรายได้ปปป',
      '20': 'สกุลเงิน',
      '30': 'รายละเอียด',
      '40': 'หน่วย',
      '50': 'จำนวนเงิน',
      '60': 'รายได้ต่อชั่วโมง',
      '70': 'รายได้ต่อวัน',
      '80': 'รายได้ต่อเดือน'
    },
    'HRES31XC6': {
      '10': 'ข้อมูลการศึกษา',
      '20': 'ลำดับ',
      '30': 'ระดับการศึกษา',
      '40': 'สาขาการศึกษา',
      '50': 'สาขาวิชา',
      '60': 'สถาบัน',
      '70': 'ประเทศ',
      '80': 'สาขาวิชาเอก',
      '90': 'เกรดเฉลี่ย',
      '100': 'ปีที่จบ',
      '110': 'วุฒิการศึกษา'
    },
    'HRES31XC7': {
      '10': 'ประสบการณ์การทำงาน',
      '20': 'ลำดับ',
      '30': 'ชื่อบริษัท',
      '40': 'ประเภทธุรกิจ',
      '50': 'ตำแหน่ง',
      '60': 'วันที่เริ่มต้น',
      '70': 'วันที่ลาออก',
      '80': 'เหตุผลการออก',
      '90': 'สถานที่ตั้ง',
      '100': 'เบอร์โทรศัพท์',
      '110': 'ชื่อหัวหน้างาน',
      '120': 'เงินเดือนล่าสุด',
      '130': 'หมายเหตุ'
    },
    'HRES31XC8': {
      '10': 'ข้อมูลบิดา-มารดา ผู้ติดต่อได้',
      '20': 'ข้อมูลบิดา',
      '30': 'ชื่อ',
      '40': 'สัญชาติ',
      '50': 'ศาสนา',
      '60': 'อาชีพ',
      '70': 'ข้อมูลมารดา',
      '80': 'ชื่อ',
      '90': 'สัญชาติ',
      '100': 'ศาสนา',
      '110': 'อาชีพ',
      '120': 'บุคคลที่ติดต่อยามฉุกเฉิน',
      '130': 'ชื่อ',
      '140': 'ความสัมพันธ์',
      '150': 'ที่อยู่',
      '160': 'รหัสไปรษณีย์',
      '170': 'เบอร์โทรศัพท์',
      '180': 'แฟกซ์',
      '190': 'อีเมล์',
      '200': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '210': 'โดย',
      '220': 'หมายเลขบัตรประชาชน',
      '230': 'หมายเลขบัตรประชาชน'
    },
    'HRES31XC9': {
      '10': 'ข้อมูลคู่สมรส',
      '20': 'รายละเอียดคู่สมรส',
      '30': 'ชื่อ',
      '40': 'เลขที่บัตรประชาชน',
      '50': 'อาชีพ',
      '60': 'วันเกิด',
      '70': 'บริษัท',
      '80': 'ข้อมูลการจดทะเบียน',
      '90': 'วันที่จดทะเบียน',
      '100': 'จังหวัด',
      '110': 'ประเทศ',
      '120': 'สถานที่จดทะเบียน',
      '130': 'ข้อมูลอื่นๆ',
      '140': 'วันที่แก้ไขครั้งสุดท้าย',
      '150': 'โดย',
      '160': 'รหัสบัตรประชาชนบิดา(คู่สมรส)',
      '170': 'รหัสบัตรประชาชนมารดา(คู่สมรส)'
    },
    'HRES31C5P1': {
      '10': 'รายละเอียดภาษี',
      '20': 'รายละเอียดภาษี',
      '30': 'หมายเลขผู้เสียภาษี',
      '40': 'วิธีการหักภาษี',
      '50': 'การยื่นแบบชำระภาษี',
      '60': 'เลขที่ประกันสังคม',
      '70': 'วันที่จ่ายเงินสมทบครบ 90 วัน',
      '80': 'สถานพยาบาลที่มีสิทธิ',
      '90': 'รายละเอียดธนาคาร',
      '100': 'รหัสธนาคาร(1)',
      '110': 'เลขที่บัญชี',
      '120': '% เข้าบัญชี',
      '130': 'รหัสธนาคาร(2)',
      '140': '% เข้าบัญชี'
    },
    'HRES31C5P2': {
      '10': 'เงินได้ยกมา',
      '20': 'เงินได้ยกมา',
      '30': 'วันที่ยกมา',
      '40': 'รายได้ยกมา',
      '50': 'เงินกองทุนสำรองฯยกมา',
      '60': 'ภาษียกมา',
      '70': 'เงินประกันสังคมยกมา',
      '80': 'เงินได้ยกมา(คู่สมรส)',
      '90': 'วันที่ยกมา',
      '100': 'รายได้ยกมา',
      '110': 'เงินกองทุนสำรองเลี้ยงชีพยกมา',
      '120': 'ภาษียกมา',
      '130': 'เงินประกันสังคมยกมา',
      '140': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '150': 'โดย'
    },
    'HRES31C5P3': {
      '10': 'เงินได้ยกเว้นภาษี',
      '20': 'รหัส',
      '30': 'รายละเอียด',
      '40': 'จำนวนเงิน',
      '50': 'จำนวนเงิน (คู่สมรส)'
    },
    'HRES31C5P4': {
      '10': 'รายการลดหย่อน',
      '20': 'รหัส',
      '30': 'รายละเอียด',
      '40': 'จำนวนเงิน',
      '50': 'จำนวนเงิน (คู่สมรส)',
      '60': 'จำนวนบุตรที่กำลังศึกษา',
      '70': 'คน',
      '80': 'จำนวนบุตรที่ไม่ศึกษา',
      '90': 'คน'
    },
    'HRES31C5P5': {
      '10': 'ส่วนหักอื่นๆ',
      '20': 'รหัส',
      '30': 'รายละเอียด',
      '40': 'จำนวนเงิน',
      '50': 'จำนวนเงิน (คู่สมรส)'
    },
    'HRES31C5P6': {
      '500': 'เลขที่บัญชี'
    },
    'HRRC21P1': {
      '0': 'ข้อมูลทั่วไป',
      '10': 'เลขที่ใบสมัคร',
      '20': 'คำนำหน้า',
      '30': 'ชื่อเล่น',
      '40': 'ชื่อ',
      '50': 'นามสกุล',
      '60': 'วันที่สมัคร',
      '70': 'ตำแหน่งที่สมัคร',
      '80': 'ระบุสาขาที่สมัคร',
      '90': 'ระบุ',
      '100': 'ไม่ระบุ',
      '110': 'เงินเดือนที่คาดหวัง',
      '120': 'สกุลเงิน',
      '130': 'แหล่งที่ทราบข่าว',
      '140': 'ชื่อรูป',
      '150': 'มีรถยนต์ส่วนตัว',
      '160': 'มี',
      '170': 'ไม่มี',
      '180': 'เคยผ่านงานหรือไม่ ?',
      '190': 'เคย',
      '200': 'ไม่เคย',
      '1001': 'ข้อมูลใบสมัคร',
      '1080': 'ข้อมูลส่วนตัว',
      '1085': 'เพศ',
      '1090': 'ชาย',
      '1095': 'หญิง',
      '1100': 'ส่วนสูง',
      '1105': 'น้ำหนัก',
      '1110': 'วันเกิด',
      '1115': 'สถานที่เกิด',
      '1120': 'เชื้อชาติ',
      '1135': 'สถานภาพการสมรส',
      '1140': 'สถานะทหาร',
      '1145': 'เลขที่บัตรประชาชน',
      '1150': 'ออกบัตรที่',
      '1165': 'English',
      '1170': 'ข้อมูลใบสมัครพนักงาน',
      '1175': 'ภาษา',
      '1180': 'รายละเอียด',
      '1185': 'ตำแหน่งสำรอง'
    },
    'STD_SKILSC': {
      '10': 'Competency Evaluation',
      '30': 'ระดับ',
      '40': 'การชี้วัด',
      '50': 'คะแนนที่ได้'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres31x.js